import { useState, useEffect, useCallback } from 'react';
import { getAllAvailableDispenseUnits } from '../api/PrescriptionsApi';

export const useDispenseUnits = () => {
    const [dispenseUnits, setDispenseUnits] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getAllAvailableDispenseUnits()
            .then(({ data }) => setDispenseUnits(data?.units || []))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const getDispenseUnitById = useCallback((unitId) => {
        return dispenseUnits.find(unit =>
            unit.StandardDispenseUnitTypeID?.toString() === unitId?.toString()
        );
    }, [dispenseUnits]);

    return { dispenseUnits, loading, getDispenseUnitById };
};
